import React from 'react';
import ReactDOM from 'react-dom';
import App from './main/app/app';
import * as serviceWorker from './serviceWorker';
import * as analytics from './analytics';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// Using Google Analytics
analytics.initialize();
